<template>
  <div
    class="grade-lesson"
    :class="{ 'grade-lesson--left': isLeftPositioned }"
    :style="position"
    ref="modal"
    @mouseleave="emitClose"
  >
    <p class="grade-lesson__date">{{ formatDate }}</p>
    <div class="grade-lesson__wrap">
      <div class="grade-lesson__icon">
        <img
          :src="env.public_base + '/assets/images/book-icon.svg'"
          alt="book"
        />
      </div>
      <div class="grade-lesson__info">
        <p class="grade-lesson__theme">{{ themeName }}</p>
        <p class="grade-lesson__lesson">{{!isThematic ?  lessonName : '' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../../../env';

export default {
  props: {
    hoverEvent: {
      type: MouseEvent,
      default: null,
    },
    gradebook: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      env,
      isLeftPositioned: false,
      position: {
        top: '10px',
        left: '10px',
        bottom: 'auto',
      },
    };
  },
  computed: {
    formatDate() {
      const dateStr = this.gradebook?.date;

      if (!dateStr) return '';

      const [year, month, day] = dateStr.slice(0, 10).split('-');

      return `${day}.${month}.${year}`;
    },
    themeName() {
      const themeName = this.gradebook?.timetable?.theme_name;
      return themeName || '';
    },
    lessonName() {
      const lessonName = this.gradebook?.timetable?.lesson_name;
      return lessonName || '';
    },
    isThematic(){
      return this.gradebook.isThematic
    }
  },
  watch: {
    gradebook: 'setPosition',
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    setPosition() {
      if (this.hoverEvent === null) return;

      const targetCell = this.hoverEvent.target;
      const cellRect = targetCell.getBoundingClientRect();
      const ww = window.innerWidth;
      const wh = window.innerHeight;

      this.$nextTick(() => {
        const modalRect = this.$refs.modal.getBoundingClientRect();
        const endLeftPoint = cellRect.left + 2 - modalRect.width;
        const endRightPoint = cellRect.right - 2 + modalRect.width;
        const endBottomPoint =
          cellRect.top + cellRect.height / 2 + modalRect.height / 2;

        this.isLeftPositioned = false;

        if (endRightPoint < ww) {
          this.position.left = `${cellRect.right - 2}px`;
        } else if (endLeftPoint > 0) {
          this.isLeftPositioned = true;
          this.position.left = `${endLeftPoint}px`;
        } else {
          this.position.left = '10px';
        }

        if (this.position.left === '10px') {
          this.position.top = '10px';
        } else if (endBottomPoint < wh) {
          this.position.top = `${cellRect.top +
            cellRect.height / 2 -
            modalRect.height / 2}px`;
        } else {
          this.position.top = `${wh - 10 - modalRect.height}px`;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../../sass/variables';

.grade-lesson {
  $this: 'grade-lesson';
  position: fixed;
  z-index: 100;
  padding: 13px;
  pointer-events: none;

  &__wrap {
    background-color: $white;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    padding: 20px;
    width: 370px;
    position: relative;
    display: flex;

    &:before {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      top: 50%;
      left: -6px;
      width: 14px;
      height: 14px;
      background-color: $white;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &__icon {
    margin-right: 13px;
    flex-shrink: 0;
  }

  &__theme {
    color: $gray--dark;
  }

  &__date {
    position: absolute;
    right: 25px;
    top: 20px;
    z-index: 1;
  }

  &--left {
    .#{$this}__wrap:before {
      right: -6px;
      left: auto;
    }
  }
}
</style>